import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Layout from './hoc/Layout/Layout';
import Home from './components/Home';
import Menu from './containers/Menu';
import AboutOurFood from './components/AboutOurFood';
import Order from './containers/Order';
import Halp from './containers/Halp';

export default function App() {
	const routes = (
		<Switch>
			<Route path="/menu" component={Menu} />
			<Route path="/about" component={AboutOurFood} />
			<Route path="/order" component={Order} />
			<Route path="/halp" component={Halp} />
			<Route path="/" exact component={Home} />
			<Redirect to="/" />
		</Switch>
	);

	return <Layout>{routes}</Layout>;
}
